// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"29840431","703":"f8a1fa96","787":"8a50b523"}[chunkId] + ".chunk.js";
};